import type { App, Component } from 'vue'

export interface Plugin {
  install: (app: App, ...options: any[]) => any
}

export type SFCWithInstall<T> = T & Plugin

export function withInstall<T extends Component>(comp: T) {
  ;(comp as SFCWithInstall<T>).install = function (app: App) {
    const { name } = comp as unknown as { name: string }
    // 将组件注册成全局组件
    app.component(name, comp)
  }
  return comp as SFCWithInstall<T>
}
